import { render, staticRenderFns } from "./top-lang.vue?vue&type=template&id=1ab6c068&scoped=true"
import script from "./top-lang.vue?vue&type=script&lang=js"
export * from "./top-lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab6c068",
  null
  
)

export default component.exports